import { ATTENTION_KIND } from '@klopotun/domain';
import type {
  AttentionItem,
  NewSubscriptionAttention,
  YearlySoonAttention,
} from '../../../entities/attention/index.js';

export type AttentionActionVariant = 'primary' | 'plain' | 'danger';

export type AttentionAction = {
  id: string;
  label: string;
  variant: AttentionActionVariant;
  onSelect: () => void;
};

export type AttentionHandlers = {
  onDismiss: (item: AttentionItem) => void;
  onConfirmSubscription: (item: NewSubscriptionAttention) => void;
  onAskNotSubscription: (item: NewSubscriptionAttention) => void;
  onAskCancel: (item: YearlySoonAttention) => void;
  onPay: (occurrenceId: string) => void;
  onVoid: (occurrenceId: string) => void;
  onOpenPayment: (paymentId: string) => void;
};

const dismissAction = (item: AttentionItem, handlers: AttentionHandlers): AttentionAction => ({
  id: 'dismiss',
  label: 'Гаразд',
  variant: 'plain',
  onSelect: () => {
    handlers.onDismiss(item);
  },
});

export const actionsOf = (item: AttentionItem, handlers: AttentionHandlers): AttentionAction[] => {
  switch (item.kind) {
    case ATTENTION_KIND.NEW_SUBSCRIPTION:
      return [
        {
          id: 'confirm',
          label: 'Так',
          variant: 'primary',
          onSelect: () => {
            handlers.onConfirmSubscription(item);
          },
        },
        {
          id: 'not-subscription',
          label: 'Це не підписка',
          variant: 'danger',
          onSelect: () => {
            handlers.onAskNotSubscription(item);
          },
        },
      ];
    case ATTENTION_KIND.YEARLY_SOON:
      return [
        { ...dismissAction(item, handlers), label: 'Так, потрібна', variant: 'primary' },
        {
          id: 'cancel',
          label: 'Скасувати підписку',
          variant: 'danger',
          onSelect: () => {
            handlers.onAskCancel(item);
          },
        },
      ];
    case ATTENTION_KIND.PAY_YOURSELF:
      return [
        {
          id: 'pay',
          label: 'Оплатити',
          variant: 'primary',
          onSelect: () => {
            handlers.onPay(item.occurrenceId);
          },
        },
        {
          id: 'void',
          label: 'Не було платежу',
          variant: 'plain',
          onSelect: () => {
            handlers.onVoid(item.occurrenceId);
          },
        },
      ];
    case ATTENTION_KIND.CHARGE_SOON:
    case ATTENTION_KIND.MISSED_CHARGE:
    case ATTENTION_KIND.PRICE_CHANGED:
      return [dismissAction(item, handlers)];
  }
};

export const openerOf =
  (item: AttentionItem, handlers: AttentionHandlers): (() => void) =>
  () => {
    handlers.onOpenPayment(item.paymentId);
  };
